import React, {useContext} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
// import landingPerson from "../../assets/lottie/landingPerson";
// import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";

import {greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👩")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />

                <Button
                  text="See my resume"
                  newTab={true}
                  href="https://drive.google.com/file/d/19VMVdwYTcbpxwHuzN4MgngHufLCsomKN/view?usp=sharing"
                  // onClick={() => window.open("/resume.pdf", "blank")}
                />
                
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <img src= {isDark ? "https://i.pinimg.com/originals/86/b4/0f/86b40f6ade107d2f0b05ef15aec03aaf.gif"
          :  "https://i.pinimg.com/originals/0c/b0/ae/0cb0aec97240b7d9746073cd3ba6c26f.gif"
          } alt="error"/>
            {/* {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src="https://media.giphy.com/media/l3vR85PnGsBwu1PFK/giphy.gif"
              ></img>
            )} */}
          </div>
        </div>
      </div>
    </Fade>
  );
}
